var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fx-formulaire-generique',{attrs:{"url-ressource":_vm.urlRessourceEndPoint + '/create'},on:{"on-submit":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }